import { PropsWithChildren } from "react";

export default function FormInputRow({ children }: PropsWithChildren) {
  return (
    <div className="flex-col flex gap-8 w-full flex-wrap md:flex-row lg:flex-row">
      {children}
    </div>
  );
}
